<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="用户姓名" prop="userId">
              <avue-input-tree
                style="width: 100%;"
                filterable
                :disabled="model == 'edit'"
                :props="sProps"
                v-model="form.userId"
                placeholder="请选择用户姓名"
                @change="userChange"
                :dic="userList"
              ></avue-input-tree>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用类型" prop="feeTypes">
              <el-select
                v-model="form.feeTypes"
                @change="feeTypesChange"
                style="width:100%"
                placeholder="请选择车位状态"
                multiple
                clearable
              >
                <el-option
                  v-for="item in feeTypesList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公众号入口" prop="h5EntrancePower">
              <el-select
                style="width:100%"
                v-model="form.h5EntrancePower"
                placeholder="请选择公众号入口"
                multiple
                clearable
              >
                <el-option
                  v-for="item in h5EntrancePowerList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属角色" prop="roleName">
              <el-input placeholder="" v-model="form.roleName" disabled> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属部门" prop="deptName">
              <el-input placeholder="" v-model="form.deptName"  disabled> </el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="小区分组" prop="communityGroup">
              <el-select style="width: 100%" v-model="form.communityGroup" placeholder="请选择小区分组" @change="groupChange">
                <el-option
                  v-for="item in communityGroupList"
                  :key="item"
                  :value="item.dictKey"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="小区名称" prop="propertyIds">
              <el-select v-model="form.propertyIds" style="width:100%" placeholder="请选择小区" multiple clearable filterable>
                <el-option
                  v-for="item in propertyList"
                  :key="item.id"
                  :label="item.roomName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getUserDetail,
  removePermission,
  getDictList,
} from '@/api/v4ward/offlinepay/user';
import {
  getParkList,
  getUserList,
  getFeeTypes,
  getCommunityGroupList,
  getOptionNode,
} from './index.js';
import { getDictionary } from '@/api/common';

export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value != '') {
        let reg = /^([0-9]|[1-9][0-9]{0,3})(\.[1-9]|\.[0-9]{1,2})?$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入小数点前4位后2位小数的面积'));
        }
      } else {
        callback();
      }
    };
    return {
      communityGroupList: [],
      propertyList: [],
      sProps: {
        label: 'namePhone',
        value: 'id',
      },
      dicProps: {
        label: 'dictValue',
        value: 'dictKey',
      },
      form: {
        roleName: '',
        feeTypes: [],
        h5EntrancePower: [],
        userId: [],
        deptName: '',
        communityGroup: '',
        propertyIds: [],
      },

      formRules: {
        userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
        feeTypes: [{ required: true, message: '费用类型不能为空', trigger: 'change' }],
        h5EntrancePower: [{ required: true, message: '公众号入口不能为空', trigger: 'change' }],
        communityGroup: [{ required: true, message: '小区分组不能为空', trigger: 'change' }],
        propertyIds: [{ required: true, message: '小区名称不能为空', trigger: 'change' }],
      },
      tableHeight: '',
      userList: [],
      feeTypesList: [],
      h5EntrancePowerList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},

  methods: {
    groupChange(val) {
      this.form.propertyIds = [];
      this.propertyList = [];
      if (val != '') {
        getOptionNode({ communityGroup: val }).then((res) => {
          this.propertyList = res.data;
        });
      }
    },
    userChange(value) {
      this.form.roleName = '';
      this.form.deptName = '';
      if (value != '') {
        getUserDetail({ userId: value }).then(({ data }) => {
          this.form.roleName = data.roleName;
          this.form.deptName = data.deptName;
        });
      }
    },
    feeTypesChange() {
      console.log(this.form.feeTypes);
    },
    async initData() {
      // getCommunityGroupList().then((res) => {
      //   this.communityGroupList = res.data;
      // });
      getOptionNode().then((res) => {
          this.propertyList = res.data;
        });
      getUserList().then((res) => {
        this.userList = res.data;
      });
      await getFeeTypes().then((res) => {
        this.feeTypesList = res.data;
      });
      await getDictionary('offlinepay_h5_entrance_power').then(({data}) => {
        this.h5EntrancePowerList = data;
      });
      if (this.model == 'add') {
        this.feeTypesList.forEach((ele) => {
          this.form.feeTypes.push(ele.dictKey);
        });
      } else {
        getDetail({ id: this.row.id }).then((res) => {
          this.form.id = res.data.id;
          this.form.userId = res.data.userId;
          this.form.feeTypes = res.data.feeTypes.split(',');
          this.form.h5EntrancePower = res.data.h5EntrancePower.split(',');
          this.form.roleName = res.data.roleName;
          this.form.deptName = res.data.deptName;
          
          this.form.propertyIds = res.data.propertyIds.split(',');
        });
      }
    },

    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let obj = {
            id: this.form.id,
            userId: this.form.userId,
            feeTypes: this.form.feeTypes.join(','),
            h5EntrancePower: this.form.h5EntrancePower.join(','),
            roleName: this.form.roleName,
            deptName: this.form.deptName,
           
            propertyIds: this.form.propertyIds.join(','),
          };
          console.log(obj);
          if (this.model == 'add') {
            add(obj).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          } else {
            update(obj).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        } else {
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped></style>
